import WidgetBox from "components/elements/WidgetBox/widget-box";
import {
  Flex,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  Checkbox,
  HStack,
} from "@chakra-ui/react";
import fees from "../../mocks/fees.json";
import { useCustomFormats } from "hooks/useCustomFormat";
import React from "react";
import { StatusFilter } from "../status-filter";
import { ActionButton } from "../action-button";
import { ExportButton } from "../export-button";
import { ColumnsButton } from "../columns-button";
import { ThSort } from "./components/th-sort";
import { ThCheckbox } from "./components/th-checkbox";
import { TdStatus } from "./components/td-status";
import { TdActions } from "./components/td-actions";
import { ThActions } from "./components/th-actions";
import { TdCheckbox } from "./components/td-checkbox";

export function FeesTable() {
  const { formatDate, formatCurrency } = useCustomFormats();
  const [selectedStatus, setSelectedStatus] = React.useState<string>("all");

  const SubTitle = () => (
    <Text fontWeight="normal" color="#6C6B6E" mt={-2}>
      Fees include all transaction fees and charges.
    </Text>
  );

  const TableFiltersAndActions = () => {
    const statuses = [
      { value: "all", label: "All" },
      { value: "Succeeded", label: "Succeeded" },
      { value: "Failed", label: "Failed" },
      { value: "Pending", label: "Pending" },
      { value: "Canceled", label: "Canceled" },
    ];

    return (
      <Flex justifyContent="space-between" gap={2}>
        <StatusFilter statuses={statuses} value={selectedStatus} onChange={setSelectedStatus} />
        <HStack gap={2}>
          <ColumnsButton />
          <ExportButton />
          <ActionButton />
        </HStack>
      </Flex>
    );
  };

  const TableData = () => {
    const filteredFees = fees.filter(
      fee => selectedStatus === "all" || fee.status === selectedStatus
    );

    return (
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <ThCheckbox />
              <ThSort>ID</ThSort>
              <ThSort>Created On</ThSort>
              <ThSort>Buyer Name</ThSort>
              <ThSort>Amount</ThSort>
              <ThSort>Status</ThSort>
              <ThSort>Payment Instrument</ThSort>
              <ThActions />
            </Tr>
          </Thead>
          <Tbody>
            {filteredFees.map(fee => (
              <Tr key={fee.id}>
                <TdCheckbox />
                <Td>{fee.id}</Td>
                <Td>{formatDate(fee.createdOn)}</Td>
                <Td>{fee.buyerName}</Td>
                <Td fontWeight="bold">{formatCurrency(fee.amount)}</Td>
                <TdStatus status={fee.status} failureReason={fee.failureReason} />
                <Td>{fee.paymentInstrument}</Td>
                <TdActions />
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <WidgetBox title="Fees">
      <Stack gap={6}>
        <SubTitle />
        <TableFiltersAndActions />
        <TableData />
      </Stack>
    </WidgetBox>
  );
}
